.separatorWhite {
    color: var(--hps-light-gray) !important;
}

.separatorBlue {
    color: var(--hps-gray) !important;
}